<vp-modal
	[closeButton]="false"
	[closeOnEscape]="false"
	[closeOnOutsideClick]="false"
	[showingModal]="showModal()"
	[testId]="'cookie-banner'"
	(emitClose)="onCloseModal()"
>
	<vp-tab-menu
		[spacing]="'compact'"
		[stretchTabs]="true"
		[(activeTab)]="activeTab"
		tabMenuId="cookie-banner-tabs"
	>
		<vp-tab-menu-item
			[content]="consentRef"
			[label]="'components.cookie-banner.permission' | translate"
			name="consent"
		/>
		<vp-tab-menu-item
			[content]="detailsRef"
			[label]="'components.cookie-banner.details' | translate"
			name="details"
		/>
		<vp-tab-menu-item
			[content]="aboutRef"
			[label]="'components.cookie-banner.about' | translate"
			name="about"
		/>
	</vp-tab-menu>

	<ng-template #consentRef>
		<p>
			<span class="h5 block pb-2 pt-3">
				{{ 'components.cookie-banner.consent.info-text' | translate }}
			</span>
			{{ 'components.cookie-banner.consent.description' | translate }}
		</p>
		<p>
			{{ 'components.cookie-banner.consent.more-info' | translate }}
			<span (click)="showAboutTab()" class="text-link">{{
				'components.cookie-banner.consent.cookie-statement' | translate
			}}</span
			>.
		</p>
		<hr class="divider -mx-4 peer-empty:hidden md:-mx-6" />
		<section class="mt-6 flex items-center justify-around">
			<div class="flex flex-col items-center">
				<label class="h5" for="functional">
					{{ 'components.cookie-banner.functional' | translate }}
				</label>
				<vp-checkbox
					[disabled]="true"
					[initialValue]="cookieValues()['valk-functional-cookie']"
					[inputId]="'functional'"
					[readonly]="true"
					[showAsToggle]="true"
					class="cursor-not-allowed"
					name="functional"
				/>
			</div>

			<div class="flex flex-col items-center">
				<label class="h5" for="analytics">
					{{ 'components.cookie-banner.analytics' | translate }}
				</label>
				<vp-checkbox
					[initialValue]="cookieValues()['valk-analytics-cookie']"
					[inputId]="'analytics'"
					[showAsToggle]="true"
					(emittedValue)="
						setCookieValue('valk-analytics-cookie', $event)
					"
					name="analytics"
				/>
			</div>

			<div class="flex flex-col items-center">
				<label class="h5" for="marketing">
					{{ 'components.cookie-banner.marketing' | translate }}
				</label>
				<vp-checkbox
					[initialValue]="cookieValues()['valk-marketing-cookie']"
					[inputId]="'marketing'"
					[showAsToggle]="true"
					(emittedValue)="
						setCookieValue('valk-marketing-cookie', $event)
					"
					name="marketing"
				/>
			</div>
		</section>
	</ng-template>

	<ng-template #detailsRef>
		<div class="flex flex-col gap-6 pt-6">
			<section class="flex flex-col">
				<div class="flex flex-row justify-between">
					<p class="h5">
						{{ 'components.cookie-banner.functional' | translate }}
					</p>
					<vp-checkbox
						[disabled]="true"
						[initialValue]="
							cookieValues()['valk-functional-cookie']
						"
						[inputId]="'functional'"
						[readonly]="true"
						[showAsToggle]="true"
						class="cursor-not-allowed"
					/>
				</div>
				<p class="mb-0 text-sm">
					{{
						'components.cookie-banner.functional.description'
							| translate
					}}
				</p>
			</section>
			<hr class="divider" />
			<section class="flex flex-col">
				<div class="flex flex-row justify-between">
					<p class="h5">
						{{ 'components.cookie-banner.analytics' | translate }}
					</p>
					<vp-checkbox
						[initialValue]="cookieValues()['valk-analytics-cookie']"
						[inputId]="'analytics'"
						[showAsToggle]="true"
						(emittedValue)="
							setCookieValue('valk-analytics-cookie', $event)
						"
					/>
				</div>
				<p class="mb-0 text-sm">
					{{
						'components.cookie-banner.analytics.description'
							| translate
					}}
				</p>
			</section>
			<hr class="divider" />

			<section class="flex flex-col">
				<div class="flex flex-row justify-between">
					<p class="h5">
						{{ 'components.cookie-banner.marketing' | translate }}
					</p>
					<vp-checkbox
						[initialValue]="cookieValues()['valk-marketing-cookie']"
						[inputId]="'marketing'"
						[showAsToggle]="true"
						(emittedValue)="
							setCookieValue('valk-marketing-cookie', $event)
						"
					/>
				</div>

				<p class="mb-0 text-sm">
					{{
						'components.cookie-banner.marketing.description'
							| translate
					}}
				</p>
			</section>
		</div>
	</ng-template>

	<ng-template #aboutRef>
		<div class="pt-3">
			<markdown [data]="legalContent() ?? ''"></markdown>
		</div>
	</ng-template>

	<article footer>
		<section class="flex flex-col gap-4 sm:flex-row">
			<button
				(click)="handleCookies('reject-all')"
				class="btn btn-primary btn-text w-full"
				data-test-id="reject-all-button"
			>
				{{ 'components.cookie-banner.decline' | translate }}
			</button>
			<button
				(click)="handleCookies('selection')"
				class="btn btn-primary btn-outline w-full"
				data-test-id="accept-selection-button"
			>
				{{ 'components.cookie-banner.accept-selection' | translate }}
			</button>
			<button
				(click)="handleCookies('accept-all')"
				class="btn btn-primary w-full"
				data-test-id="accept-all-button"
			>
				{{ 'components.cookie-banner.accept-all' | translate }}
			</button>
		</section>
	</article>
</vp-modal>
